import { Loader2 } from "lucide-react";
import { Button } from "@web/components/ui/button";

interface ReaderLoadingStateProps {
  title: string;
  message: string;
  onReturn: () => void;
}

export function ReaderLoadingState({ title, message, onReturn }: ReaderLoadingStateProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6 text-foreground">
      <section className="w-full max-w-sm rounded-3xl border bg-foreground/[0.03] p-6 text-center shadow-sm">
        <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-foreground/10">
          <Loader2 className="size-5 animate-spin" />
        </div>
        <h1 className="mt-4 truncate text-base font-semibold">{title || "正在打开书籍"}</h1>
        <p className="mt-2 text-sm text-muted-foreground">{message || "正在加载正文"}</p>
        <Button className="mt-6 w-full rounded-full" variant="outline" onClick={onReturn}>
          返回书架
        </Button>
      </section>
    </div>
  );
}
